export interface Address {
  street: string;
  postalCode: string | null;
  city: string | null;
}

export default function formatAddress({ street, postalCode, city }: Address) {
  return Object.values({ street, postalCode, city }).join(", ");
}
